/* eslint-disable no-console */

import { Map as ImmutableMap } from 'immutable';
import { isConfigReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
// @ts-expect-error UnTyped dependency
import { withEvents } from 'reporting-snowflake/relational/visualize/with-events';
import { handleDrilldown } from './DrilldownHandler';
import buildGaugeVisualization from './buildViz/gaugeVisualization';
import buildSlicedVisualization from './buildViz/slicedVisualization';
import { isGaugeChart, isSlicedChart } from 'reporting-data/tsTypes/visualization';
export const buildVisualization = ({
  datasetMap,
  chart,
  reportDetail,
  brandKitPalettes,
  originalReport,
  isMobile
}) => {
  if (isGaugeChart(chart)) {
    return buildGaugeVisualization({
      datasetMap,
      gaugeReportChart: chart,
      reportDetail,
      brandKitPalettes,
      originalReport
    });
  } else if (isSlicedChart(chart)) {
    return buildSlicedVisualization({
      datasetMap,
      partialViz: chart,
      reportDetail,
      originalReport,
      brandKitPalettes,
      isMobile
    });
  }
  throw new Error(`Unknown chart type: ${chart === null || chart === void 0 ? void 0 : chart.chartType}`);
};

/**
 * note: There is defenitely an opportunity to unified this onDrilldown handler
 */
export const attachEvents = ({
  report,
  visualization,
  dataset,
  metaStateData
}) => {
  if (isConfigReport(report)) {
    const onDrilldown = report.getIn(['displayParams', 'onChartClick']);
    return visualization.set('events', {
      onPointClick: drilldownEvent => {
        handleDrilldown({
          drilldownEvent,
          report,
          onDrilldown
        });
      }
    });
  } else if (isRelationalReport(report)) {
    const columns = report.getIn(['reportDefinition', 'columns']);
    const onDrilldown = report.getIn(['displayParams', 'onDrilldown']);
    return withEvents(ImmutableMap({
      onPointClick: drilldownEvent => {
        handleDrilldown({
          drilldownEvent,
          report,
          onDrilldown,
          deps: {
            meta: metaStateData
          },
          dataset
        });
      }
    }), visualization, columns);
  }
  return visualization;
};